import QualityReductionAlertModal from './QualityReductionAlertModal';

export default QualityReductionAlertModal;
export { QualityReductionAlertModalProps } from './QualityReductionAlertModal';
